import * as React from 'react'

import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const OnSiteIcon: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon viewBox="0 0 512 512" {...props}>
    <path
      d="M217.3 103.442c4.3 5.5 68 62.9 77 78.4h165.3c16.8 0 30.3 13.6 30.3 30.3v156.1c0 16.8-13.6 30.3-30.3 30.3H170.2c-16.8 0-30.3-13.6-30.3-30.3v-68l23.8 2.8c.8.9 1.3 1.5 2.1 2.4v30c4-1 8.4-1.3 12.9-.5 12.5 2.2 22.6 12.1 24.9 24.6.9 4.6.6 9.1-.4 13.2h225.3c-.3-1.8-.5-3.7-.5-5.6 0-17 13.8-30.7 30.7-30.7 1.8 0 3.6.2 5.4.5v-93.2c-1.8.3-3.6.5-5.4.5-17 0-30.7-13.7-30.7-30.7 0-1.9.2-3.8.5-5.6H145.4c7.8 10.6 32.2 22.4 32.2 22.4s64.9 5.8 64.9 38.7c0 .9 0 1.7-.1 2.6 0 0-2.1 24.9-73.3 4.3l-79.1-9.2s-42.9-10.3-72.6-38.7H8.6c-4.7 0-8.6-3.8-8.6-8.6v-92.5c0-4.4 3.3-8 7.6-8.5 30.8-3.3 145.3-16.1 162.7-23.6 2.8-1.2 5.6-2.2 8.6-2.6 9.8-1.7 27.8-2.3 38.4 11.2z"
      data-original="#000000"
      className="prefix__active-path"
    />
    <circle
      cx={203.058}
      cy={80.3}
      r={18.4}
      data-original="#000000"
      className="prefix__active-path"
      transform="matrix(0 -1 -1 0 489.9 489.9)"
    />
    <path
      d="M312.8 356.642c-31.7 0-58.2-22.2-64.9-51.9 1.7-.9 3.2-1.8 4.8-2.9 14.3-9.8 16.9-23.1 17.3-27.6.2-1.8.3-3.6.3-5.4 0-6.4-1.2-15.1-6-24.1 12.1-12.9 29.4-21 48.5-21 36.7 0 66.5 29.8 66.5 66.5s-29.8 66.4-66.5 66.4zm5.9-26.6c0-4 0-4.1 4-4.7 3.1-.5 6-1.4 8.9-2.6 1.6-.7 2.2-1.8 1.7-3.4-.7-2.5-1.4-4.9-2.2-7.4-.7-2.3-1.5-2.6-3.7-1.6-4.5 2.2-9.1 3.1-14.1 2.8-1.3-.1-2.6-.2-3.7-.8-4.3-1.9-4.9-6.6-1.3-9.5 1.8-1.5 3.9-2.5 6.1-3.4 3.8-1.6 7.6-3.1 11.1-5 11.4-6.3 14.5-20.6 6.4-30.4-2.9-3.5-6.7-5.9-11.1-7.1-1.9-.5-2.8-1.5-2.7-3.5s0-3.9 0-5.9c0-1.8-.9-2.7-2.6-2.7-2.1-.1-4.2-.1-6.3 0-1.9 0-2.7 1.1-2.7 2.9v4.3c0 3.2-.1 3.3-3.2 3.8-3.9.6-7.7 1.5-11.3 3.2-2.8 1.4-3.1 2.1-2.3 5 .6 2.2 1.2 4.4 1.9 6.5.8 2.5 1.5 2.8 3.8 1.6 3.9-2.1 8.1-3.2 12.5-3.8 2.8-.4 5.6-.1 8.2 1.1 4.9 2.1 5.7 7.8 1.5 11.2-1.4 1.2-3 2-4.7 2.7-4.3 1.9-8.8 3.3-12.8 5.7-6.6 3.9-10.7 9.3-10.2 17.3.5 9 5.7 14.7 13.9 17.7 3.4 1.2 3.4 1.2 3.5 4.8v3.6c.1 2.7.5 3.2 3.2 3.2h2.5c5.6.1 5.6.1 5.7-5.6z"
      data-original="#000000"
      className="prefix__active-path"
    />
  </SvgIcon>
)

export default OnSiteIcon
